import Cell from "../../../model/form/cell";
import m, {Vnode} from "mithril";
import {Questionary} from "../../../model/questionary";

export type Tree = {
    label: string,
    open: boolean,
    depth: number,
    subtree: Tree[],
    parent: Tree|null,
};

export default class UXTreeComponent {

    private readonly questionary: Questionary;
    private readonly tree: Tree = {
        label: "",
        open: true,
        depth: -1,
        subtree: [],
        parent: null,
    };
    public selectedNode: Tree|null = null;

    constructor(
        layout: Cell[][],
        private readonly onNodeClick?: (node: Tree)=>void,
    ) {
        this.questionary = layout[0][0].cellItems[0].questionary; // layout[0][0] always have LabelItem on [0]

        const path: string[] = [];

        layout.forEach(row => {
            row.forEach(cell => {
                if (!cell.visible || !cell.enabled) {
                    return;
                }
                let label = cell.cellItems[0]?.label || null;
                label = label?.trim() === '-' ? null : label;
                if (label) {
                    path[cell.column] = label;
                    this.write(path.slice(0, cell.column + 1));
                }
            });
        });
    }

    private write(path: string[], tree?: Tree): void {
        const node = tree || this.tree;
        const label = path[0];
        let subtree = node.subtree.filter(t => t.label === label)[0];
        if (!subtree) {
            subtree = {
                label: label,
                open: false,
                subtree: [],
                depth: node.depth+1,
                parent: node,
            };
            node.subtree.push(subtree);
        }
        if (path[1]) {
            this.write(path.slice(1), subtree);
        }
    }


    public open(path: string[], tree?: Tree): void {
        const node = tree || this.tree;
        node.open = true;

        const subtree = node.subtree.filter(t => t.label === path[0])[0];
        if (subtree && path[1]) {
            this.open(path.slice(1), subtree);
        }
    }

    public select(path: string[]): void {
        this.selectedNode = this.getNode(path) || null;
    }

    public reset(): void {
        this.close();
        this.selectedNode = null;
    }

    private close(tree?: Tree): void {
        const node = tree || this.tree;
        node.open = false;
        node.subtree.forEach(n => this.close(n));
    }


    private getNode(path: string[], tree?: Tree): Tree|undefined {
        const node = tree || this.tree;

        const subtree = node.subtree.filter(t => t.label === path[0])[0];
        if (subtree && path[1]) {
            return this.getNode(path.slice(1), subtree);
        } else if (!path[1])  {
            return subtree;
        }
    }

    public view(): Vnode {
        return m('.UXTreeComponent', {}, this.tree.subtree.map(st => this.viewNode(st)));
    }

    private viewNode(node: Tree): Vnode {
        return m(
            '.tree'+(node.open?'.opened':'.closed')+(node===this.selectedNode?'.selected':'')+(node.subtree.length?'.has-subtree':''),
            {},
            [
                m('label', {
                    onclick: () => {
                        node.open = !node.open
                        this.selectedNode = node;
                        this.onNodeClick?.(node);
                    },
                }, m.trust(this.questionary.renderText(node.label)) ),
                (node.open && node.subtree.length) ? m('.subtree', {},  node.subtree.map(st => this.viewNode(st))) : null
            ]
        );
    }
}